<mat-toolbar *ngIf="isLogin" class="top-nav">
    <div style="display: flex">
        <img
            src="../../assets/img/image 3.png"
            class="img-login"
            style="height: 56px"
        />
    </div>
    <span class="example-spacer"></span>
    <!-- <button
    mat-icon-button
    class="example-icon btn-signout"
    aria-label="Example icon-button with share icon"
  >
    Sign out
  </button> -->
    <button style="margin-right: 20px; line-height: 24px">
        <mat-select
            class="lang-select"
            #langSelect
            [(value)]="selectedLang"
            (selectionChange)="
                translate.use(langSelect.value); selectedValue(langSelect.value)
            "
        >
            <mat-select-trigger>
                <img
                    src="../../assets/flags/{{ selectedLang }}.svg"
                    style="width: 20px; margin-right: 8px"
                />
                <span class="lang-color">{{ selectedLang | langName }}</span>
            </mat-select-trigger>
            <ng-container *ngFor="let lang of translate.getLangs()">
                <mat-option
                    *ngIf="lang == 'th' || lang == 'en' || lang == 'cn'"
                    style="height: 36px"
                    [value]="lang"
                    [attr.selected]="lang === translate.currentLang ? '' : null"
                >
                    <img
                        src="../../assets/flags/{{ lang }}.svg"
                        style="width: 20px; margin-right: 10px"
                    />
                    {{ lang | langName }}
                </mat-option>
            </ng-container>
        </mat-select>
    </button>
    <button routerLink="/account/info">
        <mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            style="
                margin-right: 5px;
                font-size: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
            "
            >account_circle</mat-icon
        >{{ userProfile?.username }}
    </button>
    <div class="short-divider" style="margin: 0 20px"></div>

    <button
        (click)="logout()"
        mat-icon-button
        class="example-icon btn-signout"
        aria-label="Example icon-button with share icon"
    >
        <mat-icon class="sign-out-i">logout</mat-icon>
        {{ "GLOBAL.SIGN_OUT" | translate }}
    </button>
</mat-toolbar>
